import { Component } from '@angular/core';
import { AppService } from '../app.service';
import {ActivatedRoute, Router} from "@angular/router";
import {KeepAliveService} from "../utility/keep-alive.service";
import {TudiException} from "../../model/dto";
import {MessageService} from "primeng/api";
import {SeverityEnum, ToastMsg} from "../../model/page";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  account: string = '';
  password: string = '';

  constructor(
    private appService: AppService,
    private route: ActivatedRoute,
    private router: Router,
    private keepAliveService: KeepAliveService,
    private msgService: MessageService
  ) { }

  ngOnInit(): void {
    this.testing();
    console.log('receive parameters: ');
    this.route.queryParams.subscribe(params => {
      console.log(params);
    });
  }

  testing(): void {
    // this.appService.login('linhuanyu', '123456');
  }

  onLogin(): void {
    this.appService.login(this.account, this.password).subscribe({
      next: () => {
        this.keepAliveService.start();
        this.router.navigate(['case-list']);
      },
      error: err => {
        if (err.error && err.error.errorcode) {
          const tudiErr: TudiException = err.error;
          this.msgService.add(new ToastMsg(SeverityEnum.error, 'Fail to login', tudiErr.errormessage));
        }
      }
    });
  }
}
